import { render, staticRenderFns } from "./FruitCountWidget.vue?vue&type=template&id=6401fd3c&scoped=true"
import script from "./FruitCountWidget.vue?vue&type=script&lang=js"
export * from "./FruitCountWidget.vue?vue&type=script&lang=js"
import style0 from "./FruitCountWidget.vue?vue&type=style&index=0&id=6401fd3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6401fd3c",
  null
  
)

export default component.exports